import { showControlTypeName } from '@/utils/control_type'
import { Col, Row } from 'antd'
import './../Checkpoints.style.less'
import { isObjectLike } from 'lodash'

type Props = {
  data: any
  sectionName?: string
  subsectionName?: string
  reportType?: string
  editComponent?: any
}

function ControlTypeText({
  data,
  sectionName,
  subsectionName,
  reportType,
  editComponent = null,
}: Props) {
  const renderEditCheckpoint = editComponent ? (
    <Col span={1}>{editComponent()}</Col>
  ) : (
    <></>
  )
  return (
    <Col span={24}>
      <div className="control-type-multi-select-container page-break-inside">
        <Col span={12}>
          <p className="label">{showControlTypeName(data)}</p>
        </Col>
        <Col span={11}>
          <Row>
            <p
              className="value"
              style={data?.value === 'Error' ? { color: '#C03261' } : {}}
            >
              {data?.value && isObjectLike(data?.value) ? '' : data?.value}
            </p>
          </Row>
        </Col>
        {renderEditCheckpoint}
      </div>
    </Col>
  )
}

export default ControlTypeText
